<img [src]="data.img" alt="Thumbnail image" />
